import { MenuItem } from 'react-pro-sidebar'
import React, { useEffect, useRef } from 'react'
import { useLoginToAcademyMutation } from '../../store/auth/auth'
import { LinkButton } from '../Button/LinkButton'
import { TrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'

export const ZocksAcademyMenuItem: React.FC = () => {
  const [loginToAcademy, loginToAcademyMutation] = useLoginToAcademyMutation()
  const { tracked } = useTracking()
  const menuItemRef = useRef<HTMLAnchorElement>(null)
  const loading = loginToAcademyMutation.isLoading

  useEffect(() => {
    const loginUrl = loginToAcademyMutation.data?.data?.loginUrl
    if (loginUrl && menuItemRef.current && menuItemRef.current.href !== loginUrl) {
      menuItemRef.current.href = loginUrl
      menuItemRef.current.target = '_blank'
      menuItemRef.current.click()
    }
  }, [loginToAcademyMutation.data])

  const handleAcademyClick = tracked(() => loginToAcademy(null), {
    eventName: TrackEvent.ZOCKS_ACADEMY_CLICKED,
  })

  return (
    <>
      <a ref={menuItemRef} href='#' className='d-none' tabIndex={-1} rel='noreferrer' aria-hidden='true' target='_blank' />
      <MenuItem
        onClick={loading ? undefined : handleAcademyClick}
        icon={
          loading ? (
            <span className='spinner-border spinner-border-sm text-primary me-2' role='status' aria-hidden='true' />
          ) : (
            <i className='bi bi-mortarboard' />
          )
        }
        component={<LinkButton className='ps-menu-button' to='#' rel='noopener noreferrer' />}
        disabled={loading}
      >
        <div className='button-small'>{loading ? 'Loading…' : 'Zocks Academy'}</div>
      </MenuItem>
    </>
  )
}
